/**
 * Language registration for Bunny Stream Player
 * Files use standard ISO codes, but we register both ISO and legacy codes for backward compatibility
 */

import { addTranslation } from 'media-chrome/utils/i18n.js';

// Import media-chrome's built-in languages. es, pt, zh-CN and zh-TW are
// re-registered below with the player's own keys added.
import 'media-chrome/lang/fr.js';

// Import language dictionaries (using ISO standard file names)
import { Ar } from './ar.js';
import { Bg } from './bg.js';
import { Cs } from './cs.js';
import { Da } from './da.js';
import { De } from './de.js';
import { El } from './el.js';
import { Es } from './es.js';
import { Fi } from './fi.js';
import { Fr } from './fr.js';
import { Hu } from './hu.js';
import { Id } from './id.js';
import { It } from './it.js';
import { Ja } from './ja.js';
import { Ko } from './ko.js';
import { Mk } from './mk.js';
import { Nl } from './nl.js';
import { No } from './no.js';
import { Pl } from './pl.js';
import { Pt } from './pt.js';
import { Ro } from './ro.js';
import { Ru } from './ru.js';
import { Sk } from './sk.js';
import { Sl } from './sl.js';
import { Sr } from './sr.js';
import { Sv } from './sv.js';
import { Th } from './th.js';
import { Tr } from './tr.js';
import { Uk } from './uk.js';
import { Vi } from './vi.js';
import { ZhCn } from './zh-CN.js';
import { ZhTw } from './zh-TW.js';

// Register with ISO codes (standard)
addTranslation('ar', Ar);
addTranslation('bg', Bg);
addTranslation('cs', Cs);
addTranslation('da', Da);
addTranslation('de', De);
addTranslation('el', El);
addTranslation('es', Es);
addTranslation('fi', Fi);
addTranslation('fr', Fr);
addTranslation('hu', Hu);
addTranslation('id', Id);
addTranslation('it', It);
addTranslation('ja', Ja);
addTranslation('ko', Ko);
addTranslation('mk', Mk);
addTranslation('nl', Nl);
addTranslation('no', No);
addTranslation('pl', Pl);
addTranslation('pt', Pt);
addTranslation('ro', Ro);
addTranslation('ru', Ru);
addTranslation('sk', Sk);
addTranslation('sl', Sl);
addTranslation('sr', Sr);
addTranslation('sv', Sv);
addTranslation('th', Th);
addTranslation('tr', Tr);
addTranslation('uk', Uk);
addTranslation('vi', Vi);
addTranslation('zh-CN', ZhCn);
addTranslation('zh-TW', ZhTw);

// Also register with legacy codes for backward compatibility with existing user settings
addTranslation('cz', Cs); // Czech: legacy cz → ISO cs
addTranslation('dk', Da); // Danish: legacy dk → ISO da
addTranslation('gr', El); // Greek: legacy gr → ISO el
addTranslation('jp', Ja); // Japanese: legacy jp → ISO ja
addTranslation('kr', Ko); // Korean: legacy kr → ISO ko
addTranslation('si', Sl); // Slovenian: legacy si → ISO sl
addTranslation('rs', Sr); // Serbian: legacy rs → ISO sr
addTranslation('se', Sv); // Swedish: legacy se → ISO sv
addTranslation('ua', Uk); // Ukrainian: legacy ua → ISO uk
addTranslation('vn', Vi); // Vietnamese: legacy vn → ISO vi

// Export types
export type { TranslateDictionary, TranslateKeys } from './en.js';
